module.exports = __webpack_public_path__ + "static/media/homework-card-footer.5509ae66.png";